<template>
  <div class="woocommerce-notices-wrapper">
    <div class="woocommerce-message" role="alert">
      <div class="row">
        <!-- <div class="container"> -->
        <div class="col-md-12">
          <div class="h3">Ваше замовлення:</div>
        </div>
        <div class="col-md-2 photo-wrap">
          <img
            :src="`/img${productPhoto}`"
            :data-fallback="`/img${cartLastItemName.img}`"
            onerror="this.onerror=null;this.src=this.getAttribute('data-fallback')"
            :alt="cartLastItemName.name"
          />
        </div>
        <div class="col-md-10 cartN">
          <p style="font-size: 20px">
            {{ cartLastItemName.name }}
          </p>
          <p style="font-size: 20px">₴ {{ cartLastItemName.price }}</p>
          <p v-if="cartLastItemName.warranty.length">
            + {{ cartLastItemName.warranty[0].split(';')[1] }} -
            {{ cartLastItemName.warranty[0].split(';')[2] }} грн
          </p>
          <div class="close-notice" style="display: none">
            <a href="" @click.prevent="removeItem(cartLastItemName.id)">
              <i class="fa fa-times"></i>
            </a>
          </div>
        </div>
        <div v-if="cartLastItemName.profitableKit" class="cartNoticeN">
          <div v-for="d in cartLastItemName.profitableKit" :key="d.id">
            <div class="col-md-2 photo-wrap">
              <img :src="`/img${d.img}`" alt="" />
            </div>
            <div class="col-md-10">
              <p style="font-size: 20px">
                {{ d.name_ua }}
              </p>
              <p style="font-size: 20px">х1</p>
            </div>
          </div>
        </div>
        <hr />
        <div class="col-md-12">
          <div class="h3">Сума вашого замовлення: {{ totalPrice }} грн</div>
        </div>
        <hr />
        <!-- </div> -->
      </div>
      <!-- <router-link to="/checkout" tabindex="1" class="button wc-forward"> -->
      <router-link
        :to="lang ? '/' + lang + '/checkout' : '/checkout'"
        tabindex="1"
        class="button wc-forward another-btn"
      >
        {{ $t('checkout') }}
      </router-link>
      <a href="" @click.prevent="unsetAddedCartNotice">Продолжить покупки</a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CartNotice',
  computed: {
    totalPrice() {
      if (this.$store.state.cart.items[0].warranty.length) {
        return (
          this.$store.state.cart.price +
          parseInt(this.$store.state.cart.items[0].warranty[0].split(';')[2])
        )
      }
      return this.$store.state.cart.price
    },
    productPhoto() {
      const test1 = new RegExp(/^(.*?)-(\d*)x(\d*)-(\d*)x(\d*)/)
      const test2 = new RegExp(/^(.*?)-(\d*)x(\d*)/)
      const test3 = new RegExp(/^(.*?)-(\d*)x(\d*)-\d-(\d*)x(\d*)/)
      let name = this.cartLastItemName.img.split('/')
      const rawImg = name.pop()
      const img = rawImg.split(/\.(jpg|JPG|gif|GIF|png|PNG|jpeg|JPEG)$/)[0]
      const ext = rawImg.split(/\.(jpg|JPG|gif|GIF|png|PNG|jpeg|JPEG)$/)[1]
      let imgName = img

      if (test1.test(img)) {
        imgName = img.replace(/(-[^-]+)$/, '')
      } else if (test2.test(img)) {
        imgName = img.replace(/-(\d*)x(\d*)/, '')
      } else if (test3.test(img)) {
        imgName = img.replace(/(-\d-[^-]+)$/, '')
      }

      name.push(`${imgName}.${ext}`)
      return name.join('/')
    },
    ...mapGetters(['cartLastItemName']),
  },
  methods: {
    removeItem(id) {
      this.removeFromCart(id)
      this.unsetAddedCartNotice()
    },
    ...mapActions(['unsetAddedCartNotice', 'removeFromCart']),
  },
  data() {
    return {
      lang: '',
    }
  },
  beforeMount() {
    this.lang = this.$store.getters.lang
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
}
</script>

<style>
.woocommerce-notices-wrapper {
  position: fixed;
  z-index: 9999;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
}
.woocommerce-message {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  width: 70%;
  margin: 0 auto;
  max-width: 600px;
}
.close-notice {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
}
.close-notice a {
  font-size: 20px;
}

@media only screen and (max-width: 768px) {
  .woocommerce-message {
    width: 80%;
    top: 0;
    transform: unset;
  }
  .photo-wrap {
    width: 60%;
    margin: 0 auto;
    margin-bottom: 20px;
  }
  .cartNoticeN {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .cartNoticeN p {
    font-size: 14px !important;
  }
  .cartNoticeN .col-md-10 {
    display: grid;
    grid-template-columns: 5fr 1fr;
  }
  .cartN p {
    font-size: 18px !important;
    text-align: center;
    padding: 0 0 10px;
  }
}
</style>
